import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';

// 全站公共骨架：Header 和 Footer 只声明一次，中间页面由 React Router 的 Outlet 注入。
export default function Layout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}
